<template>
  <div class="sf-level-item tw-inline-flex">
    <slot></slot>
    <SfButtonDs
      icon-only
      icon-before="chevron-left"
      :aria-label="I18n.t('ledger.carousel.previous')"
      :class="
        hasLeadingSegment ? '!tw-rounded-none -tw-ml-px' : '!tw-rounded-r-none'
      "
      data-testid="carousel-prev"
      @click="handlePrevClick"
    />
    <SfButtonDs
      icon-only
      icon-before="chevron-right"
      :aria-label="I18n.t('ledger.carousel.next')"
      class="!tw-rounded-l-none -tw-ml-px"
      data-testid="carousel-next"
      @click="handleNextClick"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  previousAction: string
  nextAction: string
}

const props = defineProps<Props>()

const I18n = useI18n()

// The slot may hold a segment to the left of the chevrons, or nothing at all.
// The group's outer left corner belongs to whichever element leads it.
const slots = useSlots()
const hasLeadingSegment = computed(() => Boolean(slots.default))

function handlePrevClick() {
  window.Turbolinks.visit(props.previousAction)
}

function handleNextClick() {
  window.Turbolinks.visit(props.nextAction)
}
</script>
